import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react'
import { useController, UseControllerProps } from 'react-hook-form';

interface IProps extends UseControllerProps {
    label: string;
    disabled?: boolean;
    onChange?: (value: any) => void;
    checked?: boolean
}
const AppCheckbox = (props: IProps) => {
    const { field } = useController({ ...props, defaultValue: false })
    return (
        <FormControlLabel
            control={
                <Checkbox {...field} checked={props.checked === undefined ? field.value:props.checked} color="secondary" disabled={props.disabled} onChange={(value) => {
                    field.onChange(value);
                    if (props.onChange) {
                        if (value != null) {
                            props.onChange(value);
                        }
                    }
                }} />
            }
            label={props.label}
        />
    )
}

export default AppCheckbox